











import Vue from 'vue'
import { IBounceInfo } from '@/types/data-objects/item-histories'

export default Vue.extend({
  name: 'EmailDeliveryNotes',

  props: {
    autoResponseSent: {
      type: Boolean,
      required: true,
    },
    ccs: {
      type: Array as () => string[],
      default: null,
    },
    bounceInfo: {
      type: Object as () => IBounceInfo,
      default: null,
    },
  },

  computed: {
    hasNotes(): boolean {
      return this.hasCCs || this.hasBounceInfo || this.autoResponseSent
    },
    hasCCs(): boolean {
      return this.ccs !== null && this.ccs.length > 0
    },
    hasBounceInfo(): boolean {
      return this.bounceInfo !== null
    },
  },
})
